import React from 'react'
import ShopHeader from './Shops/ShopHeader'
import Products from './Shops/Products'
import Footer from './Footer'

export default function Shop() {
  return (
    <>
    <ShopHeader/>
    <Products />
    <Footer></Footer>
    </>
  )
}
